// @ts-nocheck
/* eslint-disable */
export const appGood16Icon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.0002" cy="7.99996" r="5.33333" fill="currentColor"/></svg>`,
    name: 'good-16' as const
};